<template>
  <div class="col-md-12">
    <div class="form-group integration-menu-top-categories">
      <label>{{ fieldLabel }}</label>
      <el-select
        v-model="selectedIds"
        multiple
        filterable
        clearable
        collapse-tags
        size="small"
        style="width: 100%;"
        :disabled="disabled"
        :placeholder="$t('gestiune.integrationsMenuTopCategoriesPlaceholder')"
        @change="onSelectionChange"
      >
        <el-option
          v-for="item in activeTopCategories"
          :key="'menu-top-cat-' + item.id"
          :value="item.id"
          :label="item.name"
        />
      </el-select>
      <small class="integration-menu-top-categories__hint mar-to-10">
        <i class="fa fa-info-circle" aria-hidden="true"></i>{{ $t('gestiune.integrationsMenuTopCategoriesHint') }}
      </small>
      <small v-if="showFilterNote" class="integration-menu-top-categories__hint">
        <i class="fa fa-info-circle" aria-hidden="true"></i>{{ $t('gestiune.integrationsMenuTopCategoriesExportNote') }}
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntegrationMenuTopCategoriesField',
  props: {
    formData: {
      type: Object,
      required: true
    },
    topCategories: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldLabelFn: {
      type: Function,
      default: null
    },
    showFilterNote: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedIds: []
    }
  },
  computed: {
    fieldLabel () {
      if (typeof this.fieldLabelFn === 'function') {
        return this.fieldLabelFn('menu_top_categories')
      }
      return this.$t('gestiune.integrationsFields.menu_top_categories')
    },
    activeTopCategories () {
      return (this.topCategories || []).filter(item => item && item.active !== false && item.active !== 0)
    }
  },
  watch: {
    'formData.menu_top_categories': {
      immediate: true,
      deep: true,
      handler (value) {
        this.selectedIds = this.normalizeIds(value)
      }
    }
  },
  created () {
    this.ensureDefault()
  },
  methods: {
    normalizeIds (value) {
      if (!Array.isArray(value)) return []
      return value
        .map(id => {
          const n = Number(id)
          return Number.isNaN(n) ? id : n
        })
        .filter(id => id !== null && id !== undefined && id !== '')
    },
    ensureDefault () {
      if (!Array.isArray(this.formData.menu_top_categories)) {
        this.$set(this.formData, 'menu_top_categories', [])
      }
    },
    onSelectionChange (value) {
      const ids = this.normalizeIds(value)
      this.$set(this.formData, 'menu_top_categories', ids)
    }
  }
}
</script>

<style scoped>
.integration-menu-top-categories {
  margin-bottom: 8px;
}
.integration-menu-top-categories__hint {
  display: block;
  font-size: 12px;
  line-height: 1.4;
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Integrations/IntegrationMenuTopCategoriesField.vue